import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Kbd — keyboard shortcut keys ("⌘", "G", "Esc"), shown in menus, tooltips
 * and empty states. Rounded square, mono, 11px on bg-300 (CORE-231).
 * Wrap a sequence in KbdGroup; read a sequence as "G then R":
 *
 *   <KbdGroup><Kbd>⌘</Kbd><Kbd>K</Kbd></KbdGroup>
 *
 * Decorative by design; pair with a visible text label (e.g. a menu item)
 * so shortcuts are never conveyed by keys alone.
 */
function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      className={cn(
        "pointer-events-none inline-flex h-[18px] min-w-[18px] select-none items-center justify-center gap-1 rounded-xs border border-line-100 bg-bg-300 px-1 font-mono text-[11px] font-medium leading-none text-ink-200",
        className,
      )}
      {...props}
    />
  );
}

function KbdGroup({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "inline-flex select-none items-center gap-0.5 text-[11px] text-ink-300",
        className,
      )}
      aria-hidden="true"
      {...props}
    />
  );
}

export { Kbd, KbdGroup };
